import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import axios from 'axios';

import './alterarDocumento.css';

import verificandoToken from '../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../config/backend';

function AlterarDocumento(props) {

    const location = useLocation();
    const objeto = location.state || {}
    const history = useHistory();

    const verificar = useCallback(async () => {
        const resultado = await verificandoApp("ATENDENTE");

        if (!resultado) {
            history.push("/");
        }
    }, [history]);

    const [seqDoc, setSeqDoc] = useState('');
    const [desDoc, setDesDoc] = useState('');
    const [nomDoc, setNomDoc] = useState('');
    const [docume, setDocume] = useState('');
    const [areDoc, setAreDoc] = useState('');
    const [, setTipDoc] = useState('');

    useEffect(() => {
        verificar();
        setSeqDoc(objeto.id);
        setDesDoc(objeto.descricao);
        setNomDoc(objeto.nome);
        setDocume(objeto.arquivo);
        setAreDoc(objeto.area);
        setTipDoc(objeto.tipo);
    }, [objeto.area, objeto.arquivo, objeto.descricao, objeto.id, objeto.nome, objeto.tipo, verificar]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        setNomDoc(file.name);

        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                setDocume(reader.result);
            };

            reader.onerror = (error) => {
                console.error("Erro ao converter o arquivo para Base64: ", error);
            };
        }
    };

    const updateDocumento = async (e) => {

        if (window.confirm("Você realmente deseja alterar o arquivo ?")) {
            e.preventDefault();

            let Arquivo64 = docume;

            verificandoToken();

            const token = localStorage.getItem('token');

            try {
                await axios.put(ensureProtocol(localStorage.getItem("ipBackend2")) + "/documentos",
                    {
                        seqDoc, desDoc, nomDoc, Arquivo64
                    },
                    {
                        headers: {
                            Authorization: `${token}`
                        }
                    });

                history.push("/historicoDocumento/" + areDoc);

            } catch (error) {
                console.error('Erro ao inserir dados:', error);
            }
        }

    }

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
            <div className="container-fluid titulo">
                <form>
                    <div className="form-group mb-3">
                        <label for="exampleFormControlInput1">Descrição</label>
                        <input placeholder={desDoc} onChange={(e) => setDesDoc(e.target.value)} type="email" class="form-control" id="descricaoDocumento" />
                    </div>
                    <div className="form-group">
                        <label for="exampleFormControlInput1">Caso não seja necessário alterar, não selecione nenhum arquivo.</label>
                        <div className="input-group mb-3">

                            <input type="file" onChange={handleFileChange} class="form-control" id="inputGroupFile02"></input>
                        </div>
                    </div>
                    <div className="form-group">
                        <button onClick={updateDocumento} class="btn btn-secondary btn-acao" type="button" id="inputGroupFileAddon03">Alterar</button>
                    </div>
                </form>
            </div>
            </main>
        </div>
    );
}

export default AlterarDocumento;